'use strict';

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
require('../utilities/radio.shim');
var polyglot = require('../utilities/polyglot').default;

var LayoutView = require('../views/layout/main').default;
var HeaderView = require('../views/header/client-view/header').default;
var StepsRouter = require('../routers/steps').default;
var OtherRouter = require('../routers/other').default;
var RescheduleRouter = require('../routers/reschedule').default;

var DetailsFirstStepsCollection = require('../collections/details-first-steps').default;
var LocationFirstStepsCollection = require('../collections/location-first-steps').default;
var ServiceFirstStepsCollection = require('../collections/service-first-steps').default;

var Appointment = require('../models/appointment').default;
var LanguageCollection = require('../collections/languages').default;

var createClientDetails = require('../utilities/client_details').default;

export default Marionette.Application.extend({

  region: '#app',

  initialize: function () {
    this.appointment = new Appointment();

    if (window.REQUEST && window.REQUEST_START) {
      const request = window.REQUEST;
      // if wait list request is no longer valid for booking, redirect
      // to the confirmation page
      if (!request.active || request.appointment_id) {
        const { origin, pathname } = Backbone.history.location;
        const lang = new LanguageCollection(window.LANGUAGES).getCurrent();
        const search = `?lang=${lang}&request_id=${request.id}&cid=${request.client.id}`;
        Backbone.history.location.href = `${origin}${pathname}${search}#${polyglot.t('pages.waitlist_confirmation.slug')}`;
      }

      this.steps = new DetailsFirstStepsCollection();
    } else if (window.SETTINGS.first_step === 'location') {
      this.steps = new LocationFirstStepsCollection();
    } else {
      this.steps = new ServiceFirstStepsCollection();
    }

    this.trackingForClient = window.SETTINGS.universal_ga_code != null;
  },

  onStart: function () {
    var self = this;
    var layout = new LayoutView({
      headerView: new HeaderView(),
    });

    this.showView(layout);

    createClientDetails(this.appointment);
    new StepsRouter({layout: layout, appointment: this.appointment});
    new OtherRouter({layout: layout});
    new RescheduleRouter({layout: layout});

    if (Backbone.history) {
      Backbone.history.start();

      this.trackPage();
      Backbone.history.on('route', function (router, route, params) {
        self.trackPage();
      });
    }

  },

  trackPage: function () {
    if (window.ga) {
      var page = Backbone.history.root + Backbone.history.fragment;
      window.ga('send', 'pageview', page);

      if (this.trackingForClient) {
        window.ga('clientTracker.send', 'pageview', page);
      }
    }
  },
});
